
<div class="reports-view">
  <page-header title="Reports">
    <template #actions>
      <align small-gap>
        <icon-button
          icon="list"
          tooltip="Audit Log"
          @click="$router.push('/audit')"
        />

        <icon-button
          v-if="isAdmin"
          icon="api"
          tooltip="API Customers"
          @click="$router.push('/api-customers')"
        />
      </align>
    </template>
  </page-header>

  <section v-if="loaded">
    <div v-if="isAdmin" class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Active Members
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Total"
          :value="$filters.number(report.totalMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Web"
          :value="$filters.number(report.webMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Mobile"
          :value="$filters.number(report.mobileMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Employees"
          :value="$filters.number(report.employeeMembers)"
        />
      </div>
    </div>

    <div v-if="isAdmin" class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Paid Members
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Total"
          :value="$filters.number(report.totalPaidMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Web"
          :value="$filters.number(report.webPaidMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Mobile"
          :value="$filters.number(report.mobilePaidMembers)"
        />

        <stat-item
          size="xlarge"
          success
          label="CC"
          :value="$filters.number(report.collectorsClubMembers)"
        />
      </div>
    </div>

    <div v-if="isAdmin" class="widget">
      <graph-overview
        v-if="dailyTotalPaidMembers"
        title="Daily Total Paid Members"
        y-axis-type="number"
        :zoom.sync="zoom"
        :scale.sync="scale"
        :stats="totalPaidNumbersStats"
        :graph-values="[dailyTotalPaidMembers]"
      />
    </div>

    <div v-if="isAdmin" class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Other Members
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Total Free Trial"
          :value="$filters.number(report.totalFreeTrialers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Web Free Trial"
          :value="$filters.number(report.webFreeTrialers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Mobile Free Trial"
          :value="$filters.number(report.mobileFreeTrialers)"
        />

        <stat-item
          size="xlarge"
          success
          label="Free Members"
          :value="$filters.number(report.freeMembers)"
        />
      </div>
    </div>

    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Verify Cards
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Cards in Progress"
          :value="$filters.number(report.progressCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Cards in Review"
          :value="$filters.number(report.reviewCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Back to Progress"
          :value="$filters.number(report.monthlyMovedBackCount)"
        />
      </div>
    </div>

    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Cards Added
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Today"
          :value="$filters.number(dailyAddedCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Weekly"
          :value="$filters.number(report.weeklyAddedCount)"
        />

        <stat-item
          size="xlarge"
          success
          label="Monthly"
          :value="$filters.number(report.monthlyAddedCount)"
        />
      </div>
    </div>

    <div class="widget">
      <align class="header" flex>
        <h3 class="secondary-font">
          Profiles
        </h3>
      </align>

      <div class="grid">
        <stat-item
          size="xlarge"
          success
          label="Total Matched"
          :value="$filters.number(report.profilesMatchedManually + report.profilesMatchedAutomatically)"
        />

        <stat-item
          size="xlarge"
          success
          label="Manually Matched"
          :value="$filters.number(report.profilesMatchedManually)"
        />

        <stat-item
          size="xlarge"
          success
          label="Automatically Matched"
          :value="$filters.number(report.profilesMatchedAutomatically)"
        />
      </div>
    </div>

    <div class="employees">
      <h4 class="secondary-font">
        Employees
      </h4>

      <div class="employee-list-view">
        <align flex collapse-end>
          <div />

          <direction-sort-options
            :sort.sync="sort"
            :direction.sync="direction"
            :options="sortOptions"
          />
        </align>

        <div class="results">
          <template v-if="loaded">
            <div class="list">
              <employee-list-item
                v-for="employee in employees"
                :key="employee.uid"
                :to="`/employee/${employee.uid}`"
                :employee="employee"
                :fields="['totalAddedCount', 'monthlyAddedCount', 'monthlyMovedBackCount', 'reviewCount']"
                as="router-link"
              />
            </div>
          </template>

          <spinner v-else />
        </div>
      </div>
    </div>
  </section>

  <spinner v-else />
</div>
